import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Input } from '../../../components';
import { GeneralService } from '../../../services';

const ModalCreateSupplier = ({ onClose, onSuccess }) => {
  const { form, isLoading, onChange, submit } = useForm({ onClose, onSuccess });

  return (
    <div className="w-[24rem] px-4 bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] overflow-y-auto">
      <div className="flex items-center justify-between py-4">
        <h2 className="text-lg font-bold text-text">Agregar proveedor</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <Input
        label="Nombre"
        value={form.name || ''}
        onValueChange={v => onChange('name', v)}
      />

      <div className="flex justify-center mt-2 px-6 py-4 gap-3">
        <button
          type="button"
          className="px-6 py-2 bg-gray-200 text-text font-semibold rounded-full hover:bg-gray-300 transition-colors text-sm"
          onClick={onClose}
          disabled={isLoading}
        >
          Cerrar
        </button>
        <button
          type="button"
          className="px-6 py-2 bg-red text-white font-semibold rounded-full hover:bg-gray-800 transition-colors text-sm disabled:opacity-50"
          onClick={submit}
          disabled={isLoading}
        >
          Guardar
        </button>
      </div>
    </div>
  );
};

const useForm = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({ name: '' });
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (target, value) => {
    setForm(s => ({ ...s, [target]: value }));
  };

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.name.trim())
      return onError('Debe indicar el nombre del proveedor');

    return true;
  };

  const submit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      await GeneralService.setSupplier(form);
      toast.success('Proveedor creado con éxito');
      onSuccess?.();
      onClose?.();

    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  };

  return {
    form,
    isLoading,
    onChange,
    submit,
  };
};

export default ModalCreateSupplier;
